
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 38 38","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M8.682 33.751c1.136-.84 2.007-2.974 2.007-2.974s.981-.68 1.288-1.55c.307-.869.017-2.05.017-2.05s.87-2.553.46-3.268c-.41-.715-2.147-1.176-2.147-1.176s-.716-1.33-2.199-1.586c-.972-.101-1.943-.765-1.943-2.147 0-1.38 1.38-3.63 1.38-3.63s1.433-.7 1.637-1.212c.204-.511.274-1.703.274-1.703s1.362-2.403.595-3.784c-.245-.44-1.38-.767-1.38-.767l-1.593-2.39M33.327 28.938c-1.813-.391-4.897-.49-4.897-.49s-2.474-1.584-3.894-1.216c-1.419.367-2.703 1.841-2.703 1.841s.44 2.31 0 2.496c-.437.183-1.743-.27-2.434.313-.69.584-.058 1.853-.058 1.853s-1.594.642-1.733 1.105c-.138.463.805 1.312 1.013 1.66","stroke":"#111","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15.372 1.366C7.17 3.044 1 10.302 1 19c0 9.94 8.059 18 18 18s18-8.06 18-18c0-.455-.017-.905-.05-1.35","stroke":"#111","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{staticClass:"fill",attrs:{"d":"M26.594 5.82a2.41 2.41 0 110 4.82 2.41 2.41 0 010-4.82","fill":"#111"}}),_c('path',{attrs:{"d":"M33.823 8.292c0 5.137-7.228 11.765-7.228 11.765s-7.23-6.628-7.23-11.765c0-4.614 3.737-7.292 7.23-7.292 3.493 0 7.228 2.678 7.228 7.292z","stroke":"#111","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])])
          )
        }
      }
    